import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { WristbandsService } from '@app/shared/services/wristbands.service';

import { ApiService, AuthenticationService, ThemeService, SnackBarService } from '@shared/services';

@Component({
    selector: 'app-info-user-form',
    templateUrl: './info-user-form.component.html',
    styleUrls: ['./info-user-form.component.scss'],
    standalone: false
})
export class InfoUserFormComponent implements OnInit {
userInfoId: any;
myForm: FormGroup;
walletId: string;
wristId:string;
name: string;
email: string;
surname: string;
phone: string;
userId: string;
eventId: string;
userPass: {ScannedUserid: any};
loading = true;
infoPass: {ScannedUserid: any, hasBidirectionalLeadScanner: boolean};
infoPass1: {ScannedUserid: any, hasLeadScannerComment: boolean, comment: string};
texto = (localStorage.getItem('lang') === 'es') ? 'Usuario ya importado' : 'User already imported';
errormessage = false;
submitted = false;
hasComment = false;
bidirectional = false;
comment: string;

  constructor(
    public wristbandService: WristbandsService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    public snackBarService: SnackBarService,
    public themeService: ThemeService,
    public dialog: MatDialog,
    private auth_service: AuthenticationService
  ) {
     this.myForm = this.formBuilder.group({
      name: [this.name],
      surname: [this.surname],
      email: [this.email],
      phone: [this.phone],
      comment: [this.comment]
    });
  }

  ngOnInit(): void {
    this.userPass = {ScannedUserid : 'aaa'};
    const event = JSON.parse(localStorage.getItem('eventSelected'));
    this.eventId = event.id;
    this.userId = this.auth_service.user.id;
    this.bidirectional = this.wristbandService.bidirectional;
    this.saveUserInfo();
    this.hasComment = this.wristbandService.comment;
  }

  saveUserInfo() {
    this.infoPass = {ScannedUserid: this.userPass.ScannedUserid, hasBidirectionalLeadScanner: this.bidirectional};
    this.apiService.post(`events/${this.eventId}/users/${this.userId}/saveRegister`, this.infoPass).subscribe({next: (data) => {
      this.name = data[0]['name'];
      this.surname = data[0]['surname'];
      this.email = data[0]['email'];
      this.phone = data[0]['phone'];
      if(data[0]['comment']){
        this.comment = data[0]['comment'];
      }
      this.loading = false;
      },
       error: (err) => {
          console.error(err);
          // this.errormessage = err['error'];
          this.errormessage = true;
          this.loading = false;
            }
      });
  }

  saveComment() {
    if (!this.myForm.value.comment){
      this.myForm.value.comment = this.comment;
    }
    this.infoPass1 = {ScannedUserid: this.userPass.ScannedUserid, hasLeadScannerComment: this.hasComment, comment: this.myForm.value.comment};
    this.apiService.post(`events/${this.eventId}/users/${this.userId}/saveComment`, this.infoPass1).subscribe({next: (data) => {
      this.loading = false;
      this.snackBarService.openSnackBar((localStorage.getItem('lang') === 'es') ? 'Usuario agregado con éxito.' : 'User successfully added.');
      //this.onClose();

      //this.location.back();
      },
      error:  (err) => {
          console.error(err);
          // this.errormessage = err['error'];
          this.errormessage = true;
          this.loading = false;
      }
    });
  }
}
